import jwtDecode from "jwt-decode"
import { useMemo } from "react"
import { useJwtToken } from "./useJwtToken"

export function useProfileId(): string {
  const { token } = useJwtToken()

  const ownerId: string = useMemo<string>(() => {
    if (!token) return ""
    return (jwtDecode(token) as { primarysid: string }).primarysid
  }, [token])

  return ownerId
}
